import axios from "axios";

// Cria uma instância do Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API, // Defina a URL base do seu backend
  // timeout: 5000, // Tempo limite da requisição (5 segundos)
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

console.log(process.env.REACT_APP_BASE_URL);

// Intercepta requisições para adicionar o token de autenticação
api.interceptors.request.use(
  (config) => {
    // Busca o token no localStorage ou sessionStorage
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepta respostas para lidar com erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Se não autorizado, remove o token e redireciona para o login
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      window.location.href = "/login"; // Ajuste a rota conforme necessário
    }
    return Promise.reject(error);
  }
);

export default api;
